import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { safeLs } from 'utils/localStorage';

import accountEN from './en/account.json';
import authEN from './en/auth.json';
import commonEN from './en/common.json';
import customersEN from './en/customers.json';
import menuEN from './en/menu.json';
import paymentsEN from './en/payments.json';
import topUpsEN from './en/top_ups.json';
import traderAccountEN from './en/trader_account.json';
import traderDepositsEN from './en/trader_deposits.json';
import traderPayoutsEN from './en/trader_payouts.json';
import traderStatisticsEN from './en/trader_statistics.json';
import withdrawalsEN from './en/withdrawals.json';
import accountRU from './ru/account.json';
import authRU from './ru/auth.json';
import commonRU from './ru/common.json';
import customersRU from './ru/customers.json';
import menuRU from './ru/menu.json';
import paymentsRU from './ru/payments.json';
import topUpsRU from './ru/top_ups.json';
import traderAccountRU from './ru/trader_account.json';
import traderDepositsRU from './ru/trader_deposits.json';
import traderPayoutsRU from './ru/trader_payouts.json';
import traderStatisticsRU from './ru/trader_statistics.json';
import withdrawalsRU from './ru/withdrawals.json';

export const defaultNS = 'common';

export const resources = {
  en: {
    account: accountEN,
    auth: authEN,
    common: commonEN,
    customers: customersEN,
    menu: menuEN,
    payments: paymentsEN,
    ['top_ups']: topUpsEN,
    withdrawals: withdrawalsEN,
    ['trader_deposits']: traderDepositsEN,
    ['trader_payouts']: traderPayoutsEN,
    ['trader_account']: traderAccountEN,
    ['trader_statistics']: traderStatisticsEN,
  },
  ru: {
    account: accountRU,
    auth: authRU,
    common: commonRU,
    customers: customersRU,
    menu: menuRU,
    payments: paymentsRU,
    ['top_ups']: topUpsRU,
    withdrawals: withdrawalsRU,
    ['trader_deposits']: traderDepositsRU,
    ['trader_payouts']: traderPayoutsRU,
    ['trader_account']: traderAccountRU,
    ['trader_statistics']: traderStatisticsRU,
  },
} as const;

const lng = safeLs?.getItem?.('i18n') ?? 'ru';
export const supportedLanguages = Object.keys(resources);

export const i18n = i18next.use(initReactI18next).init({
  resources,
  supportedLngs: supportedLanguages,
  lng,
  fallbackLng: 'ru',
  ns: Object.keys(resources.en),
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
});
